// 微信相关方法
export default {
  data() {
    return {
      wxMenuIsHide: false,
    }
  },

  methods: {
    /**
     * 隐藏微信菜单
     */
    wxHideMenu() {
      this.wxMenuIsHide = true
      wx.ready(() => {
        wx.hideMenuItems({
          menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'],
        })
      })
    },

    wxShowMenu() {
      wx.ready(() => {
        wx.showMenuItems({
          menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'],
        })
      })
    },
  },

  beforeDestroy() {
    if (this.wxMenuIsHide) {
      this.wxShowMenu()
    }
  },
}
